@if (initialized && dto) {
    @if (uiMode == 'side') {

        <bm-billing-area-side
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)"
        ></bm-billing-area-side>

    } @else {
        <bm-billing-area-full
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)"
        ></bm-billing-area-full>
    }
}
